import { Injectable } from '@angular/core';
import { LanguageService } from '@/app/core/services/language.service';
import { TranslateService } from '@ngx-translate/core';
import { Observable, of } from 'rxjs';
import { RoleEnum } from '@/app/consts/role.const';

@Injectable({
  providedIn: 'root'
})
export class LabelService {
  constructor(private readonly languageService: LanguageService, private readonly translate: TranslateService) {}

  getRoleLabel(role?: RoleEnum | '' | null): string | null {
    const targetRole = role ?? '';
    if (!targetRole) {
      return null;
    }
    const key = `role.${targetRole}`;
    const translated = this.languageService.instant(key);
    if (translated === key) {
      return targetRole; // Translation not found but return the role itself
    }
    return translated;
  }

  /**
   * Reactive getter for role label.
   * Returns an Observable that resolves when translation is available.
   * Components can use this with the async pipe or subscribe directly.
   */
  getRoleLabel$(role?: RoleEnum | '' | null): Observable<string | null> {
    const targetRole = role ?? '';
    if (!targetRole) {
      return of(null);
    }
    return this.translate.get(`role.${targetRole}`);
  }
}
